import initialState from './initialState'
import { LOGOUT_USER } from 'common/redux/constants'
import { reducer as loadSchemaToCompareReducer } from './loadSchemaToCompare'
import { reducer as setItemsToCompareReducer } from './setItemsToCompare'
import { reducer as removeItemsToCompareReducer } from './removeItemsToCompare'
import { reducer as loadBrandsReducer } from './loadBrands'
import { reducer as loadModelsReducer } from './loadModels'
import { reducer as loadYearsReducer } from './loadYears'
import { reducer as loadVersionsReducer } from './loadVersions'
import { reducer as loadVehicleReducer } from './loadVehicle'
import { reducer as handleOpenModalFormReducer } from './handleOpenModalForm'

const reducers = [
    setItemsToCompareReducer,
    loadSchemaToCompareReducer,
    removeItemsToCompareReducer,
    loadBrandsReducer,
    loadModelsReducer,
    loadYearsReducer,
    loadVersionsReducer,
    loadVehicleReducer,
    handleOpenModalFormReducer,
]

export default function reducer(state = initialState, action = {}) {
    let newState
    if (action.type === LOGOUT_USER) {
        newState = initialState
    } else {
        newState = state
    }
    return reducers.reduce((s, r) => r(s, action), newState)
}
